<template>
    <b-row class="mx-0 mt-2 mb-1" align-h="between">
      <b-col>
        <div v-if="hasData">
          <b-table
            ref="alertsDetailsTable"
            class="table-with-actions-min-height"
            responsive
            striped
            outlined
            :items="alertsFilter"
            :fields="computedTableFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
          >
            <template #cell(time)="row">
              {{ formatDate(row.value) }}
            </template>
            <template #cell(severity)="row">
              <SeverityBehavior :severity="row.value"></SeverityBehavior>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationTotalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-2 mx-1"
          />
        </div>
        <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
          {{ $t("No Data Available") }}
        </div>
      </b-col>
    </b-row>
</template>

<script>
import moment from 'moment';

import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';
import SeverityBehavior from '@/xvisor/components/xtend/tabs/SeverityBehavior.vue';
import XomesEventBus from '@/xvisor/bus/XomesEventBus';

export default {
  components: {
    SeverityBehavior,
  },
  props: {
    alertDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      alerts: [],
      loaded: false,
      currentPage: 1,
      sortDesc: true,
      sortBy: 'time',
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        {
          key: 'time', label: 'Time', sortable: true, thStyle: { width: '20%' },
        },
        {
          key: 'type', label: 'Type', sortable: true, thStyle: { width: '20%' },
        },
        {
          key: 'message', label: 'Message', sortable: true, thStyle: { width: '40%' },
        },
        {
          key: 'severity', label: 'Severity', sortable: true, thStyle: { width: '20%' },
        },
      ],
    };
  },
  computed: {
    hasData() {
      return this.alertDetails && Object.keys(this.alertDetails).length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.alertsFilter.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    alertsFilter() {
      const retVal = this.alertDetails;
      return retVal;
    },
  },
  methods: {
    formatDate(dateStr) {
      return moment(dateStr).format(momentTimeFormat.dateYearTime);
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(selected) {
      if (selected && selected.length > 0) {
        XomesEventBus.$emit('update-selected-metadata', selected[0].metadata);
      } else {
        XomesEventBus.$emit('update-selected-metadata', {});
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.alertsFilter && this.alertsFilter.length > 0) {
        this.$refs.alertsDetailsTable.selectRow(0);
      }
    });
  },
};
</script>

<style scoped>
  .header-card {
    width: 100%;
  }
  .header-card>.card-body {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
  .details-row {
    gap: 1rem;
  }
</style>
